<template>
  <v-row >
    <v-col>
      <h2><b>Registro: </b></h2><p></p>
      <p> {{ item.observacao }} </p> 
      </v-col>
  </v-row>
</template>

<script>

export default {
  name: "AcionamentoExpand",
  props: {
    item: Object,
  },
}
</script>

